import React from 'react';
import { Box, Card, CardContent, Grid, Typography } from '@mui/material';
import { Home, Person, Mail, AttachMoney } from '@mui/icons-material';
import { WorkspacePremium } from '@mui/icons-material';
import palette from 'src/theme/palette';

const DashboardListingCard = ( {listings} ) => {
  const iconColor = palette.primary.main;
  const data = [
    {
      icon: <Home sx={{ color: iconColor, fontSize: 30 }} />,
      value: listings?.data?.active_listings,
      label: 'Active Listings'
    },
    {
      icon: <Person sx={{ color: iconColor, fontSize: 30 }} />,
      value: listings?.data?.active_leads,
      label: 'Active Leads'
    },
    {
      icon: <WorkspacePremium sx={{ color: iconColor, fontSize: 30 }} />,
      value: listings?.data?.featured_properties,
      label: 'Featured Properties'
    }
  ];
  
  return (
    <Grid 
      container 
      spacing={3} 
      sx={{ p: 5 , pl: 3 }}
    >
      {data.map((item, index) => (
        <Grid item xs={12} sm={6} md={4} key={index}>
          <Card
            sx={{
              borderRadius: 1,
              cursor: 'pointer',
              boxShadow: '0px 4px 12px rgba(0,0,0,0.1)',
              transition: '0.3s',
              '&:hover': {
                boxShadow: '0px 4px 12px rgba(0,0,0,0.1)',
                transform: 'translateY(-4px)'
              }
            }}
          >
            <CardContent sx={{ p: 3 }}>
              <Box 
                display="flex" 
                flexDirection={'column'} 
                justifyContent="center" 
                alignItems="center"
              >
                <Box display="flex" alignItems="center" gap={2}>
                  {item.icon}
                  <Typography
                    sx={{
                      fontSize: 22,
                      fontFamily: 'poppinsSemiBold'
                    }}
                  >
                    {item.value}
                  </Typography>
                </Box>

                <Box  pl={4} >
                  <Typography
                    sx={{
                      fontSize: 16,
                      fontFamily: 'poppinsRegular',
                      mt: 1
                    }}
                  >
                    {item.label}
                  </Typography>
                </Box>
              </Box>
            </CardContent>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default DashboardListingCard;
